






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IArticleCard } from "@/store/interfaces/article";
import ellipsizeTextBox from "@/services/textElip";
import { mapGetters } from "vuex";
import { URL } from "@/config";

@Component({
  name: "ArticleCard",
  computed: {
    ...mapGetters("app", ["isFontLoad", "isLangDetected", "lang"])
  }
})
export default class ArticleCard extends Vue {
  @Prop({ default: null })
  article: IArticleCard;
  currentLang: string = localStorage.getItem("currentLang");

  elepsize: boolean = false;

  mounted() {
    ellipsizeTextBox(this.$refs["title"]);
  }

  async created() {
    if (localStorage.getItem("currentLang") === "br") {
      this.currentLang = "br";
    } else this.currentLang = localStorage.getItem("currentLang");
  }

  @Watch("lang")
  async onLangChanged() {
    if (localStorage.getItem("currentLang") === "br") {
      this.currentLang = "br";
    } else this.currentLang = localStorage.getItem("currentLang");
  }

  createImgLink(name) {
    if (name.search(/http/g) !== -1) {
      return name;
    }
    return `${URL}/images/` + name.split(".")[0] + "-sm." + name.split(".")[1];
  }
}
